/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_End_Time_SmpteInputs */



/**
* | output |
* | --- |
* | "End Time (SMPTE)" |
*
* @param {Markers_Export_End_Time_SmpteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_end_time_smpte = /** @type {((inputs?: Markers_Export_End_Time_SmpteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_End_Time_SmpteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Heure de fin (SMPTE)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endzeit (SMPTE)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ora di fine (SMPTE)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время окончания (SMPTE)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hora de finalización (SMPTE)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结束时间（SMPTE）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時刻（SMPTE）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति समय (एसएमपीटीई)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Hora de término (SMPTE)")
	return /** @type {LocalizedString} */ ("End Time (SMPTE)")
});